import React from 'react';

import { useIntl } from 'react-intl-next';

import SignatureIcon from '@atlaskit/icon-lab/core/signature';

import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { useSelectFilter } from '../../../../../controllers/filters/base-select-filter';
import { useFiltersDiscoverability2Enabled } from '../../../../../controllers/store/bootstrap';
import { filter as salesforceStageFilter } from '../../../../../controllers/store/search/filters/salesforce-stage';

import { i18n } from './messages';

const SalesforceStageFilter = ({
	isFilterInDropdown,
	fit = 'default',
	onFilterChange,
	hideOnHoverOut,
	onClearOptions,
}: FilterProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const isFiltersDiscoverability2Enabled = useFiltersDiscoverability2Enabled();
	const [filterData, { loadInitialOptions, setOption, clearOptions }] = useSelectFilter({
		filterId: salesforceStageFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const { isLoading, suggestedOptions, selectedOptions } = filterData;

	const groupedOptions = [
		{
			label: formatMessage(i18n.salesforceStageFilterLabelSelected),
			options: selectedOptions,
		},
		{
			label: formatMessage(i18n.salesforceStageFilterLabelUnselected),
			options: suggestedOptions,
		},
	];

	const label =
		fit === 'compact' && selectedOptions.length > 0
			? ''
			: formatMessage(i18n.salesforceStageFilterLabel);

	return (
		<SelectFilter
			contentFit={fit}
			canClearFilter
			checkboxIndicators
			onDropdownOpen={loadInitialOptions}
			onSelectChange={(option, ...restArgs) => {
				setOption(option, ...restArgs);
				onFilterChange?.(option);
			}}
			options={groupedOptions}
			selectedOptions={selectedOptions}
			label={label}
			filterOrControlId={'salesforceStage'}
			isLoading={isLoading}
			isSearchable={false}
			onClearOptions={() => {
				clearOptions();
				onClearOptions?.({ filterId: salesforceStageFilter.id });
			}}
			isFilterInDropdown={isFilterInDropdown}
			isFiltersDiscoverability2Enabled={isFiltersDiscoverability2Enabled}
			iconBefore={<SignatureIcon label="" />}
			hideOnHoverOut={hideOnHoverOut}
		/>
	);
};

export default SalesforceStageFilter;
